import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconHorizonOrangeSizeS from './IconHorizonOrange_size_s';

const props: CreateIconArguments = {
  l: IconHorizonOrangeSizeS,
  m: IconHorizonOrangeSizeS,
  s: IconHorizonOrangeSizeS,
  xs: IconHorizonOrangeSizeS,
  name: 'IconHorizonOrange',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
